module.exports = __webpack_public_path__ + "img/stones.b9fd986.jpg";